import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { Buffer } from 'buffer';
import { Chart, registerables } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import { etiquetaCompleta } from './app/shared/data-access/utils/recortar-texto';

(window as any).Buffer = Buffer;

// Register Spanish locale data for Angular pipes (e.g., DatePipe)
registerLocaleData(localeEs);

// Register Chart.js globally to prevent scale/controller errors on standalone views
// annotationPlugin va aqui y no por [plugins]: solo Chart.register ejecuta su afterRegister, que
// registra los tipos de anotacion (label, box...) con sus defaults. Sin eso el gauge falla con
// "reading 'borderCapStyle'". Registrarlo antes del bootstrap garantiza que ningun grafico exista
// sin su estado (el problema que habia cuando lo registraba gauge.component con PreloadAllModules).
Chart.register(...registerables, annotationPlugin);

// Etiquetas acortadas en un gráfico (recortarEtiquetas): el tooltip muestra el nombre completo. Los gráficos con su
// propio callback `title` lo siguen usando; los demás, sin etiquetas acortadas, quedan con el título de Chart.js.
const tituloTooltip = Chart.defaults.plugins.tooltip.callbacks.title;
Chart.defaults.plugins.tooltip.callbacks.title = function (this: any, items: any[]) {
  const item = items[0];
  return (item && etiquetaCompleta(item.chart.data.labels, item.dataIndex)) ?? (tituloTooltip as any).call(this, items);
};

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
